import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <section className="footer__enquiry">
        <div className="footer__enquiry-container">
          <Link to="/contact-us" className="footer__enquiry-link">
            Enquire about Harpwood House <span className="footer__arrow">▶</span>
          </Link>
        </div>
      </section>
      <div className="footer__container">
        <section className="contact-section">
          <div className="contact-section__content">
            <p>Harpwood House Limited, Seven Mile Lane, Wrotham Heath, Sevenoaks, Kent, TN15 7RY</p>
            <p>Copyright © Harpwood House</p>
          </div>
        </section>
      </div>
    </footer>
  );
}

export default Footer;
